export function formatNumber(
  number: number | string,
  options?: { defaultValue?: string; fragments?: number },
) {
  options = options ?? {};
  const defaultValue = options.defaultValue ?? "";
  const fragments = options.fragments ?? 0;

  if (number === undefined || number === null || number === "")
    return defaultValue;

  if (typeof number === "string") number = parseFloat(number);

  return new Intl.NumberFormat("da-DK", {
    minimumFractionDigits: fragments,
    maximumFractionDigits: fragments,
  }).format(number);
}

export function squareMetersToHectares(squareMeters: number): number {
  const hectares = squareMeters / 10000;
  return parseFloat(hectares.toFixed(2));
}
